module.exports = __webpack_public_path__ + "static/media/calendar.b6f79b7a.png";